import { getPostHog } from './posthog-client';

// Product-analytics taxonomy. Add domain events here as the app grows; treat
// the string values as an append-only contract (renaming breaks funnels).
export enum AnalyticsEvent {
  // Generic adoption signals — replace/extend with real product events.
  FeatureViewed = 'feature_viewed',
  FeatureUsed = 'feature_used',

  // Performance
  WebVitalCollected = 'web_vital_collected',
}

const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;

const SENSITIVE_KEY_PATTERNS = [
  /ssn/i,
  /password/i,
  /token/i,
  /secret/i,
  /api[_-]?key/i,
  /credit[_-]?card/i,
  /cvv/i,
  /card[_-]?number/i,
];

function isSensitiveKey(key: string): boolean {
  return SENSITIVE_KEY_PATTERNS.some((pattern) => pattern.test(key));
}

function containsEmail(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  return EMAIL_REGEX.test(value);
}

export function validateProperties(
  properties: Record<string, unknown>,
): { ok: true } | { ok: false; reason: string } {
  for (const [key, value] of Object.entries(properties)) {
    if (isSensitiveKey(key)) {
      return { ok: false, reason: `sensitive property key "${key}"` };
    }
    if (containsEmail(value)) {
      return {
        ok: false,
        reason: `property "${key}" appears to contain an email address`,
      };
    }
  }
  return { ok: true };
}

export function trackEvent(
  event: AnalyticsEvent,
  properties?: Record<string, unknown>,
): void {
  const client = getPostHog();
  if (!client) return;

  if (properties) {
    const result = validateProperties(properties);
    if (!result.ok) {
      console.warn(`[analytics] dropping event "${event}": ${result.reason}`);
      return;
    }
  }

  client.capture(event, properties);
}
